export const welfareAndExitReason = {
  checkingBannerMoney: '<span style="font-size: 16px;font-weight: bold;">8折<br>加油折扣</span>',
  checkingBannerSubtitle: '可至【个人中心】-【小拉加油】查看',
  checkingBannerTitle: '审核通过即可参与优惠加油活动',
  cityBtnWelfare: '加油8折起',
  exitReason: [
    '证件/车辆不在身边',
    '信息已被其他账号绑定',
    '不符合加入条件',
    '城市有疫情/交通封禁，不继续注册',
    '随便看看',
  ],
  processWelfareText: '加油8折起',
  registerBtnWelfare: '加油8折起',
  stepFirstProcessText:
    '还差<span style="color: #ff4553">2步</span>，获取优惠加油福利',
  stepSecondProcessText:
    '还差<span style="color: #ff4553">1步</span>，获取优惠加油福利',
};

// 欢迎页兜底文案配置（日、夜间均24小时兜底）
export const welcomePageText = {
  auditDesc: '预计<span style="color: #000;font-weight: bold;">24小时</span>内审核完成。',
  auditWithEduDesc: '预计<span style="color: #000;font-weight: bold;">24小时</span>内审核完成。你可先开始出车培训，审核通过后可直接开始抢单',
}
